import { useState } from "react";

function useCopyToClipboard() {
  const [copied, setCopied] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);

  const copy = async (text, copiedIndex = null) => {
    if (!navigator.clipboard) {
      console.warn("Clipboard API not supported");
      return false;
    }
    try {
      await navigator.clipboard.writeText(text);
      console.log("Copied to clipboard: ", text);
      setCopied(true);
      setCopiedIndex(copiedIndex);
      setTimeout(() => setCopied(false), 5000); // Reset after 5 seconds
      return true;
    } catch (err) {
      console.error("Failed to copy: ", err);
      return false;
    }
  };

  return [copied, copiedIndex, copy];
}

export default useCopyToClipboard;
